import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useCreateStandardizationProject = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(async (projectData) => {
    const newProject = await axios.post('/standardization', projectData);
    return newProject;
  });

  const createProject = (formData, { onSuccess }) => {
    mutate(formData, {
      onSuccess: (res) => {
        queryClient.invalidateQueries('standardizationProjects', { exact: true });
        toast.success(`The new project ${res.data.name} is successfully created`);
        onSuccess && onSuccess(res.data);
      },
      onError: (res) => {
        toast.error(res.message);
      },
    });
  };

  return {
    createProject,
    isLoading,
  };
};

export default useCreateStandardizationProject;
